export default __webpack_public_path__ + "static/media/SpeechRight.81ef2589.svg";